<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
        <div class="tabs" style="float: right">
          <div class="tab" v-for="(item,index) in tabList" :key="item.key" :class="tabKey == item.key?'tab-active': ''"
            @click="handleChange(item,index)">
            <label class="tab-title">{{item.title}}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="m-panel-body">
      <div style="position: absolute;right: 0;z-index: 9;">
        <a-radio-group default-value="0" v-model="timeType" @change="onChange2" size="small">
          <a-radio-button :value="0">
            {{ $t('近七天') }}
          </a-radio-button>
          <a-radio-button :value="1">
            {{ $t('近一月') }}
          </a-radio-button>
          <a-radio-button :value="2">
            {{ $t('近半年') }}
          </a-radio-button>
        </a-radio-group>
      </div>
      <!-- <div id="chart" style="height: 100%;width: 100%;"></div> -->
      <Echart ref="option" :options="option" style="height: 100%"></Echart>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts/lib/echarts';
  import {
    postAction
  } from '@/api/manage'
  export default {
    data() {
      return {
        title: this.$t('业务趋势'),
        tabList: [
          {
            key: -1,
            title: this.$t('全部')
          },
          {
            key: 0,
            title: this.$t('换表')
          },
          {
            key: 1,
            title: this.$t('工程报装')
          },
          {
            key: 2,
            title: this.$t('故障报修')
          },
        ],
        tabKey: -1,
        url: {
          queryBusinessTrends: "/jeecg-engineering/ticket/index/largeScreen/queryBusinessTrends"
        },
        option: {},
        timeType: 0
      }
    },
    mounted() {},
    methods: {
      init() {
        this.getData(this.tabKey==-1?'':this.tabKey,0)
      },
      handleChange(item) {
        this.tabKey = item.key
        this.getData(this.tabKey==-1?'':this.tabKey,this.timeType);
      },
      onChange2(e) {
        this.timeType = e.target.value;
        this.getData(this.tabKey==-1?'':this.tabKey,this.timeType);
      },
      getData(ticketsType,timeType){
        postAction(this.url.queryBusinessTrends,{ticketsType:ticketsType,timeType:timeType}).then(res=>{
          if(res.success){
            var data = res.result;
            var xData = [];
            var yDataNum = [];
            var yDataRate = [];
            if(timeType == 0||timeType == 1){
              data.map(item=>{
                xData.push(item.time.split(' ')[0].split('-')[1]+'-'+item.time.split(' ')[0].split('-')[2]);
                yDataNum.push(item.ticketsNum);
                yDataRate.push(item.finishRate*100);
              })
            }else{
              data.map(item=>{
                xData.push(item.time.split(' ')[0].split('-')[0]+'-'+item.time.split(' ')[0].split('-')[1]);
                yDataNum.push(item.ticketsNum);
                yDataRate.push(item.finishRate*100);
              })
            }
            this.setOption(xData,yDataNum,yDataRate)
          }
        })
      },
      setOption(xData,yDataNum,yDataRate) {
        let seriesData = []
        seriesData[0] = {
          name: this.$t('工单数'),
          type: 'bar',
          barMaxWidth: 14,
          stack: 'sum',
          smooth: true,
          symbol: "none",
          animationDelay: (0 * 200) - 100,
          animationDuration: 300,
          data: yDataNum
        }
        seriesData[1] = {
          name: this.$t('完结率(%)'),
          type: 'line',
          yAxisIndex: 1,
          symbol: 'circle',
          animationDelay: 1000,
          stack: 'Total',
          smooth: true,
          animationDuration: 300,
          data: yDataRate
        }
        this.$refs.option.hideLoading()
        this.option = {
          color: ['#4634FA', '#F6BB2F', '#50E3C2', '#32C5FF', '#0091FF', '#0394FF', '#0C2D82', '#B620E0', '#F7B500',
            '#FA6400', '#E02020'
          ],
          title: {
            show: false
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,11,42,0.9)',
            borderColor: '#5D6A94',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#CEE2FF',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#019AF3'
              }
            },
            // formatter: '{a0}: {c0}<br/>{a1}: {c1}'
          },
          legend: {
            type: 'scroll',
            data: [this.$t('工单数'), this.$t('完结率(%)')],
            textStyle: {
              color: '#CEE2FF'
            },
            // icon: 'circle',
            itemHeight: 10,
            left: 'left',
            // pageIconColor: '#aaa',
            // pageIconInactiveColor: '#2f4554',
            // pageTextStyle: {
            //   color: 'rgb(91, 135, 195)'
            // }
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: xData,
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: ['#074671'],
              }
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 10
            }
          },
          yAxis: [{
              type: 'value',
              interval: 10,
              name: this.$t('工单数(件)'),
              nameTextStyle: {
                color: '#D1F3FF',
                align: 'center',
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dotted',
                  color: ['#074671'],
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                color: '#D1F3FF',
                fontSize: 10
              }
            },
            {
              type: 'value',
              min: 0,
              max: 100,
              interval: 20,
              name: this.$t('完结率(%)'),
              nameTextStyle: {
                color: '#D1F3FF',
                align: 'center',
              },
              splitLine: {
                show: false,
                lineStyle: {
                  type: 'dotted',
                  color: ['#074671'],
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value} %',
                color: '#D1F3FF',
                fontSize: 10
              }
            }
          ],
          series: seriesData
        };
      },
      // setOption() {
      //   var chartDom = document.getElementById('chart');
      //   var myChart = echarts.init(chartDom);
      //   var option = {
      //     textStyle: {
      //       color: '#fff'
      //     },
      //     grid: {
      //       bottom: '10%'
      //     },
      //     tooltip: {
      //       trigger: 'axis',
      //       axisPointer: {
      //         type: 'cross',
      //         crossStyle: {
      //           color: '#fff'
      //         }
      //       }
      //     },
      //     legend: {
      //       top: '3%',
      //       left: '3%',
      //       textStyle: {
      //         color: '#fff'
      //       },
      //     },
      //     xAxis: [{
      //       type: 'category',
      //       data: ['04月','05月','06月'],
      //       axisPointer: {
      //         type: 'shadow'
      //       },
      //     }],
      //     yAxis: [{
      //         type: 'value',
      //         axisLabel: {
      //           formatter: '{value}'
      //         }
      //       },
      //       {
      //         type: 'value',
      //         axisLabel: {
      //           formatter: '{value} %'
      //         }
      //       }
      //     ],
      //     series: [{
      //         name: '工单总数',
      //         type: 'bar',
      //         tooltip: {
      //           valueFormatter: function(value) {
      //             return value + ' ml';
      //           }
      //         },
      //         data: [20,33,44],
      //         barWidth: 20,
      //         itemStyle: {
      //           normal: {
      //             color: '#3BA1FF',
      //             barBorderRadius: [5, 5, 0, 0]
      //           }

      //         }
      //       },
      //       {
      //         name: '完结(%)',
      //         type: 'line',
      //         yAxisIndex: 1,
      //         tooltip: {
      //           valueFormatter: function(value) {
      //             return value + ' °C';
      //           }
      //         },
      //         data: [11,23,34],
      //         itemStyle: {
      //           color: '#FF9898'
      //         }
      //       }
      //     ]
      //   }
      //   option && myChart.setOption(option);
      // }
    },
  }
</script>
<style lang="less" scoped>
  .tabs {
    display: flex;
    position: absolute;
    right: 0;
  }

  .tab {
    padding: 6px 8px;
    margin: 0 0 0 0;

    cursor: pointer;
  }

  .tab-active {
    position: relative;
  }

  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;

  }

  .tab:last-child {

    margin-right: 0;
  }

  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }

  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }

  .trends-box {}

  .ant-radio-button-wrapper {
    color: #fff;
    background: transparent;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #1890FF;
  }
</style>